<template>
	<div>
		<h1 class="alpha heavy center">Reset Your Password</h1>
		<form class="mt-2" @submit.prevent="submit">
			<fieldset>
				<div>
					<div v-if="!success" class="input-group">
						<label><span>Email </span>
							<input v-model="form.data.email" type="email"/>
							<div v-if="form.errors.get('email')" class="error-block">
								<p v-html="form.errors.get('email')"></p>
							</div>
						</label>
						<label><span>Password </span>
							<input v-model="form.data.password" type="password"/>
							<div v-if="form.errors.get('password')" class="error-block">
								<p v-html="form.errors.get('password')"></p>
							</div>
						</label>
						<label><span>Confirm password </span>
							<input v-model="form.data.password_confirmation" type="password"/>
							<div v-if="form.errors.get('password_confirmation')" class="error-block">
								<p v-html="form.errors.get('password_confirmation')"></p>
							</div>
						</label>
					</div>
					<OutcomeBadge
						v-else
						:result="true"
						class="center" message="Your password has been reset"/>
				</div>
			</fieldset>
			<ul v-if="!success" class="actions wide">
				<li>
					<process-button
						:processing="form.processing" class="button button--primary--wide" text="Reset Password"/>
				</li>
			</ul>
		</form>
		<ul class="sub-actions">
			<li>
				<router-link
					:to="{name: 'login'}" class="heavy" v-html="!success ? 'Remembered your password?' : 'Login'"/>
			</li>
		</ul>
	</div>
</template>
<script>
import OutcomeBadge from "../../../../common/components/OutcomeBadge";

export default {
	components: {
		OutcomeBadge,
	},
	data() {
		return {
			form: this.newForm({
				email: "",
				password: "",
				password_confirmation: "",
			}).setHttpClient(http(true)).setStore(),
			success: false,
		};
	},

	methods: {
		async submit() {
			this.form.processing = true;
			await http(true).get("sanctum/csrf-cookie");
			await this.form.post(window.location.pathname).then(() => {
				this.success = true;
			});
		},
	},
};
</script>
